import { render } from "./LabelsList.vue?vue&type=template&id=b960d3bc&scoped=true"
import script from "./LabelsList.vue?vue&type=script&lang=js"
export * from "./LabelsList.vue?vue&type=script&lang=js"

import "./LabelsList.vue?vue&type=style&index=0&id=b960d3bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b960d3bc"]])

export default __exports__